import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.7771 14.6926H19.7755L13.157 13.1854C12.5846 13.757 12.1837 14.4995 12.0426 15.3313C8.58587 14.1226 5.85218 11.3843 4.66091 7.93069L4.6625 7.9291C5.50586 7.7934 6.26101 7.39262 6.84143 6.81622V6.81463L5.35512 0.231513C5.14028 0.154853 4.91743 0.0957831 4.68814 0.0590698C4.46689 0.0191512 4.23923 0 4.00835 0C1.80856 0 0.02245 1.76591 0.00159544 3.95018C-8.31292e-10 3.96454 0 3.97733 0 3.99169V4.0332C0 12.8245 7.13323 19.9553 15.95 19.9984C15.9644 20 15.9772 20 15.9917 20H16.0061C18.2139 19.992 20 18.2085 20 16.0083C20 15.788 19.9824 15.5708 19.9455 15.3601C19.9102 15.1301 19.8525 14.9066 19.7771 14.6926Z",
      fill: ""
    }, null, -1)
  ])))
}
export default { render: render }